import {
  RECEIVE_ROLES,
} from '../constants/ActionTypes';

const roles = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_ROLES:
      return action.payload;
    default:
      return state;
  }
}

export default roles;



// WEBPACK FOOTER //
// ./src/reducers/roles.js